import { render, staticRenderFns } from "./phone_setting.vue?vue&type=template&id=1400bf6a&scoped=true&"
import script from "./phone_setting.vue?vue&type=script&lang=js&"
export * from "./phone_setting.vue?vue&type=script&lang=js&"
import style0 from "./phone_setting.vue?vue&type=style&index=0&id=1400bf6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400bf6a",
  null
  
)

export default component.exports